import { Badge } from "@/components/ui/badge";
import { Clock, AlertTriangle } from "lucide-react";
import { formatStartTime } from "@/lib/datetime-utils.js";
import { getOngoingDowntimeBadgeClass } from "@/lib/downtime-duration-styles.js";
import DowntimeTypeBadge from "@/components/downtime-type-badge.jsx";

/** Map event.mechanical (true/false/null) to DowntimeTypeBadge type (1=Mech, 2=Non-Mech, 0=Unknown). */
function mechanicalToBadgeType(mechanical) {
  return mechanical === true ? 1 : mechanical === false ? 2 : 0;
}

export function EventTimeline({ events }) {
  return (
    <div className='space-y-4 flex flex-col h-full min-h-0'>
      <h3 className='font-semibold flex items-center gap-2 flex-shrink-0'>
        <Clock className='w-5 h-5' />
        Event History
      </h3>

      <div className='relative space-y-4 pl-6 overflow-y-auto flex-1 min-h-0'>
        {events.map((event, index) => (
          <div
            key={event.id}
            className='relative pr-1'
            data-testid={`event-${index}`}>
            <div
              className={`absolute -left-6 top-2 w-3 h-3 rounded-full border-2 ${
                event.mechanical === true
                  ? "bg-blue-500 border-blue-300"
                  : event.mechanical === false
                    ? "bg-yellow-500 border-yellow-300"
                    : "bg-gray-400 border-gray-300"
              }`}
            />

            <div className='space-y-2 pb-4 border-b last:border-0'>
              <div className='flex items-start justify-between gap-4 flex-wrap'>
                <div className='flex-1 min-w-0'>
                  <p className='font-medium text-sm truncate'>
                    {event.relatedAlarm}
                  </p>
                  <div className='flex items-center gap-2 mt-1 text-xs text-muted-foreground'>
                    <span>{formatStartTime(event.dateTime)}</span>
                    {event.endDate && (
                      <>
                        <span>→</span>
                        <span>
                          {new Date(event.endDate).toLocaleTimeString("en-US", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </span>
                      </>
                    )}
                  </div>
                </div>
                <div className='flex items-center gap-2'>
                  {event.active && (
                    <Badge
                      variant='status'
                      className={getOngoingDowntimeBadgeClass("text-xs")}>
                      Ongoing
                    </Badge>
                  )}
                  <DowntimeTypeBadge
                    type={mechanicalToBadgeType(event.mechanical)}
                  />
                  {event.dtHours && (
                    <Badge variant='outline' className='text-xs font-mono'>
                      <AlertTriangle className='w-3 h-3 mr-1' />
                      {event.dtHours.toFixed(1)} h
                    </Badge>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
